import React, { useContext, useEffect, useState } from 'react'
import './tool-panel.less'
import { IconButton } from 'bimui';
import { EngineContext, RegisterContext } from '@/App';
import { ReactComponent as CloseSvg } from 'bimui/dist/c1/icons/cancel.svg'
import { useNavigate, useParams } from 'react-router-dom';
import { coreAxios } from '@/declare/api/axios';
import { emitter } from '@/utils/mitt';
import { Emit_Event_Common_Tool } from '@/declare/enums/emit-event';
import localStore from "../../../store/local-store";

export default function ToolPanel() {
    // 注册存储
    const registerContext = useContext(RegisterContext);
    const engineContext = useContext(EngineContext); // 获取上下文
    const navigate = useNavigate();
    const { projectUuid, modelUuid } = useParams();
    const [toolPanelInitStatus, setToolPanelInitStatus] = useState<{}>({});

    /**
     * 初次加载时判断是否弹出工具面板
     */
    useEffect(() => {
        const majorUuid = localStore.activeMajor;
        const activeToolKey = localStore.getToolKeyByMajor(majorUuid);
        if (activeToolKey) {
            registerContext.activeTool(activeToolKey)
        }
    }, [])

    /**
     * 拿到面板的缓存状态
     */
    useEffect(() => {
        if (registerContext.currentActivedToolKey == null) return;
        const status = localStore.getToolPanelStatus(registerContext.currentActivedToolKey);
        setToolPanelInitStatus(status);
    }, [registerContext.currentActivedToolKey])


    // 当前激活的侧边栏
    const ActiveToolPanel = registerContext.toolPanels[registerContext.currentActivedToolKey];



    if (ActiveToolPanel == null) return null;

    return (
        <div className='tool-panel-container'>
            <IconButton wrapClassName='close-icon' small icon={<CloseSvg />} onClick={() => {
                registerContext.activeTool(null);
            }}></IconButton>

            <ActiveToolPanel
                {...engineContext}
                projectUuid={projectUuid}
                axios={coreAxios}
                emitter={emitter}
                emitterType={Emit_Event_Common_Tool}
                navigate={(key) => navigate(key)}
                activeToolPanel = {(key: string) => {
                    registerContext.activeTool(key);

                }}
                panelInitStatus={toolPanelInitStatus}
                onStatusChange={(status) => {
                    localStore.setToolPanelStatus(registerContext.currentActivedToolKey, status);
                }}
            />
        </div>
    )
}
